<div class="multi-select-dropdown">
    <div class="dropdown-header" (click)="toggleDropdown()">
        <div class="selected-items" [ngClass]="{ 'font-black': selectedItems.length > 0 }">
            {{ getSelectedMsg() }}
        </div>
        <div class="search-dropdown-arrow"></div>
        <div
            *ngIf="selectedItems.length > 0"
            style="
                background-image: url('../../../../assets/user-group/icon-clear-small.svg');
                background-repeat: no-repeat;
                height: 25px;
                width: 25px;
                position: relative;
                top: 2px;
                right: 9px;
                padding-right: 25px;
            "
            class="cursor-pointer icon-clear"
            (click)="clearList()"
        ></div>
        <!-- <div class="dropdown-icon">&#9660;</div> -->
    </div>
    <div class="dropdown-list" *ngIf="dropdownOpen">
        <div class="search-box">
            <input type="text" placeholder="Search" [(ngModel)]="searchTerm" class="search-input" />
        </div>
        <div class="checkbox-group">
            <label class="checkbox">
                <input [(ngModel)]="isSelectAll" [disabled]="filteredItems.length === 0" type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection()" />
                Select All
            </label>
        </div>
        <div class="checkbox-group" *ngFor="let item of filteredItems">
            <label class="checkbox display-oneline" title="{{ item.name }}">
                <input type="checkbox" [checked]="isItemSelected(item)" (change)="toggleItemSelection(item)" />
                {{ displayname == 'name' ? item.name : item.label }}
            </label>
        </div>
    </div>
</div>
